import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import '../../assets/css/styles.css';//css

import images from '../../helpers/images';
import Carousel from 'react-bootstrap/Carousel';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'

import LearnMoreContent from '../parts/LearnMoreContent';
import httpService from '../../helpers/httpService';
import store from '../../helpers/store';
 
function HomePage (){
    const wpRoot = window.location.host;
    const queryString = window.location.search ?? '';
    let url = 'https://www.worldvision.org.ph/donate/level-up' + queryString
    const [campaigns, setCampaigns] = useState(store.camapaigns)
    const [is_loaded, setLoaded] = useState(0)
   
    useEffect(() => {
        getCMS()
    }, []);

    function learnMoreModal(item, data){
        let test = <h1>Hellow World</h1>

        const MySwal = withReactContent(Swal)

        MySwal.fire({ 
        html: <LearnMoreContent item={item} data={data} />,
        })
    }

    function getCMS(){
        let resourceUrl = 'https://cms.worldvision.org.ph/wp-json/acf/v3/pages/246';
        const headers = { 'Content-Type': 'application/json' }

        fetch(resourceUrl, { headers })
            .then(response => response.json())
            .then(data => {
                if(data.hasOwnProperty('acf')){
                    setCampaigns(data.acf)
                }
        
                setLoaded(1)
            })
            .catch((err) => {
                setLoaded(1)
            });   
    }

    function displayCarousel(){
        let slide = []

        if(Object.keys(campaigns.level_up_campaigns).length > 0){
            slide = Object.entries(campaigns.level_up_campaigns).map(([index, data]) => {
                const bg_color = data.color ?? '#842e14';
                const btn_class = data.button_class ?? 'orange-btn'

                return  <Carousel.Item>
                            <div className="campaign-item d-flex align-items-center" style={{backgroundColor: bg_color}}>
                                <div className="container">
                                    <div className="row d-flex align-items-center justify-content-center">
                                    <div className="col-lg-5 me-lg-5 order-1 caption">
                                        <div>
                                            <h1 className="mb-3 fw-bold">{data.title}</h1>
                                            <p className="fs-4 mb-4">{data.description}</p>
                                            <div>
                                                <a href={url} className={`mb-3 mb-lg-0 ${btn_class}`}>GIVE TODAY</a>
                                                <a onClick={(e) => learnMoreModal('', data)} className='ms-3 text-light' style={{cursor: 'pointer'}}>Learn More</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 order-2">
                                        <img src={data.image} className="img-fluid rounded" />
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </Carousel.Item>
            })
        }

            return <Carousel indicators={false} interval={null}>
                        {/* {slide} */}
                <Carousel.Item>
                    <div className="campaign-item d-flex align-items-center bg-green">
                        <div className="container">
                            <div className="row d-flex align-items-center justify-content-center">
                            <div className="col-lg-5 me-lg-5 order-1 caption">
                                <div>
                                    <h1 className="mb-3 fw-bold">ENOUGH</h1>
                                    <p className="fs-5 mb-4">In 2022, as many as 783 million people in the world faced hunger and 2.4 billion people (nearly one-third or 29.6% of the world) did not have enough to eat. An estimated 45 million children suffered from wasting (form of malnutrition), which increases the risk of death by 11 times. <b>Give ENOUGH, Act ENOUGH, Pray ENOUGH until there is ENOUGH of the right food on the table for every family.</b></p>
                                    <div>
                                        <a href={url} className="orange-btn mb-3 mb-lg-0">GIVE TODAY</a>
                                        <a onClick={(e) => learnMoreModal('enough')} className='ms-3 text-light' style={{cursor: 'pointer'}}>Learn More</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 order-2">
                                <img src={images.campaign_enough} className="img-fluid rounded" />
                            </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
                {/* <Carousel.Item>
                    <div className="campaign-item d-flex align-items-center bg-blue">
                        <div className="container">
                            <div className="row d-flex align-items-center justify-content-center">
                            <div className="col-lg-5 me-lg-5 order-1 caption">
                                <div>
                                    <h1 className="mb-3 fw-bold">CHILDHOOD RESCUE</h1>
                                    <p className='fs-4 fw-bold'>Survive, Recover and Build a Future</p>
                                    <p className="fs-5 mb-4">In the world’s most dangerous places, life can change in an instant. Six years later after the Marawi siege, thousands of homeless children and their families are still recovering from its impact.</p>
                                    <div>
                                        <a href={url} className="orange-btn mb-3 mb-lg-0">GIVE TODAY</a>
                                        <a onClick={(e) => learnMoreModal('childhood-rescue')} className='ms-3 text-light' style={{cursor: 'pointer'}}>Learn More</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 order-2">
                                <img src={images.campaign_chr} className="img-fluid rounded" />
                            </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item> */}
                <Carousel.Item>
                    <div className="campaign-item d-flex align-items-center bg-light-green">
                        <div className="container">
                            <div className="row d-flex align-items-center justify-content-center">
                            <div className="col-lg-5 me-lg-5 order-1 caption">
                                <div>
                                    <h1 className="mb-3 fw-bold w-100">START UP</h1>
                                    <p className="fs-4 mb-4">Empowering families to generate their own sustainable income is part of our development work in the communities we serve. We are eager to multiply success stories from being a livelihood assistance beneficiary to business owner.</p>
                                    <div>
                                        <a href={url} className="orange-btn mb-3 mb-lg-0">GIVE TODAY</a>
                                        <a onClick={(e) => learnMoreModal('start-up')} className='ms-3 text-light' style={{cursor: 'pointer'}}>Learn More</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 order-2">
                                <img src={images.campaign_start_up} className="img-fluid rounded" />
                            </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className="campaign-item d-flex align-items-center bg-orange">
                        <div className="container">
                            <div className="row d-flex align-items-center justify-content-center">
                            <div className="col-lg-5 me-lg-5 order-1 caption">
                                <div>
                                    <h1 className="mb-3 fw-bold">STUDY UP</h1>
                                    <p className="fs-4 mb-4">Quality education enables children to break free from poverty and reach for their dreams. Improving their learning outcomes include promoting literacy and numeracy, providing adequate learning tools and materials, and creating safe and stimulating learning environments.</p>
                                    <div>
                                        <a href={url} className="blue-btn mb-3 mb-lg-0">GIVE TODAY</a>
                                        <a onClick={(e) => learnMoreModal('study-up')} className='ms-3 text-light' style={{cursor: 'pointer'}}>Learn More</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 order-2">
                                <img src={images.campaign_study_up} className="img-fluid rounded" />
                            </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className="campaign-item d-flex align-items-center bg-purple">
                        <div className="container">
                            <div className="row d-flex align-items-center justify-content-center">
                            <div className="col-lg-5 me-lg-5 order-1 caption">
                                <div>
                                    <h1 className="mb-3 fw-bold">WASH UP</h1>
                                    <p className="fs-5 mb-4"><b>Every child has the right to drink and use clean and safe water.</b> World Vision partners with communities and donors to encourage positive knowledge, attitudes and practices towards water, sanitation, and hygiene. We also make clean and safe water accessible to more children and their families by improving functional water facilities in communities.</p>
                                    <div>
                                        <a href={url} className="orange-btn mb-3 mb-lg-0">GIVE TODAY</a>
                                        <a onClick={(e) => learnMoreModal('wash-up')} className='ms-3 text-light' style={{cursor: 'pointer'}}>Learn More</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 order-2">
                                <img src={images.campaign_wash_up} className="img-fluid rounded" />
                            </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
                {/* <Carousel.Item>
                    <div className="campaign-item d-flex align-items-center bg-maroon">
                        <div className="container">
                            <div className="row d-flex align-items-center justify-content-center">
                            <div className="col-lg-5 me-lg-5 order-1 caption">
                                <div>
                                    <h1 className="mb-3 fw-bold">PERFORM UP</h1>
                                    <p className="fs-5 mb-4">Provide opportunities for talented and passionate children to showcase their musical talent and express their creativity. A holistic environment creates a platform for children to learn and develop important life skills such as discipline, teamwork, and communication.</p>
                                    <div>
                                        <a href={url} className="blue-btn mb-3 mb-lg-0">GIVE TODAY</a>
                                        <a onClick={(e) => learnMoreModal('perform-up')} className='ms-3 text-light' style={{cursor: 'pointer'}}>Learn More</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 order-2">
                                <img src={images.campaign_perform_up} className="img-fluid rounded" />
                            </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item> */}
                {/* <Carousel.Item>
                    <div className="campaign-item d-flex align-items-center" style={{backgroundColor: '#842e14'}}>
                        <div className="container">
                            <div className="row d-flex align-items-center justify-content-center">
                            <div className="col-lg-5 me-lg-5 order-1 caption">
                                <div>
                                    <h1 className="mb-3 fw-bold">DAPAT READY</h1>
                                    <p className="fs-4 mb-4">Disasters disrupt children’s lives and deprive them of food, shelter, education, and their most basic needs. We operate on the ground to deliver life-saving aid and skills assistance before, during, and after disasters to help children and their families become more resilient to natural and manmade calamities.</p>
                                    <div>
                                        <a href={url} className="orange-btn mb-3 mb-lg-0">GIVE TODAY</a>
                                        <a onClick={(e) => learnMoreModal('dapat-ready')} className='ms-3 text-light' style={{cursor: 'pointer'}}>Learn More</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 order-2">
                                <img src={images.campaign_dapat_handa} className="img-fluid rounded" />
                            </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item> */}
            </Carousel>
    }

    function getBannerContent(){
        return <div className="container d-flex align-items-center">
                    <div className="row">
                        <div className="col-lg-8 col-md-12">
                            <img src={images.multiColorLine} width={350} />
                            <h1 className="mt-0">Level Up!</h1>
                            <p>UPLIFT the future of Filipino kids by setting up their chance to achieve an impact of a lifetime!</p>
                            <a href={url} className="orange-btn">GIVE TODAY</a>
                        </div>
                        <div className="clear" />
                    </div>
                </div>
    }
    
    return (
        <>
        <div id="banner-section" className='banner-desktop' style={{background: `#F9F8F7 url(${campaigns.desktop_banner}) no-repeat center`, backgroundSize: 'cover'}}>{getBannerContent()}</div>
        <div id="banner-section" className='banner-mobile' style={{background: `#F9F8F7 url(${campaigns.mobile_banner}) no-repeat center center`, backgroundSize: 'cover'}}>{getBannerContent()}</div>
        <div className="levelup-campaigns">
            {is_loaded ? displayCarousel() : ''}
        </div>

        </>
    )
}
 
export default HomePage;